<template lang="pug">
#selecionar-car
    el-input#idInputCar.mt-2.mb-3(
        :placeholder='$t("mensagens.laudos.digiteONumeroDoCar ")',
        prefix-icon='el-icon-search',
        v-model='carSelecionado',
        @change='buscarCar',
        @keyup.native.enter='buscarCar'
    )
    .conteudo
        div(v-if='carExibicao')
            h3.mb-3 {{ $t('mensagens.laudos.informacoesDoCar') }}
            p.mb-1 {{ $t('mensagens.laudos.areaHa') }}: {{ carExibicao.areaHa }}
            p.mb-1 {{ $t('mensagens.comuns.municipioUf') }}: {{ carExibicao.municipioUF }}
            p.mb-1 {{ $t('mensagens.laudos.situacao') }}: {{ carExibicao.situacao }}
    el-divider.custom-divider
    .botao.marginButton(slot='footer')
        BaseButton.cancel-button(type='outline', @click='cancelarModal') {{ $t('mensagens.comuns.cancelar') }}
        BaseButton#idAdicionar.confirm-button(
            type='primary',
            @click='enviarCarSelecionado',
            :disabled='!existeCarNaBaseLyra || !isValid'
        )
            | {{ $t('mensagens.comuns.confirmar') }}
</template>

<script>
import UtilsService from '@/services/UtilsService';
import formatters from '@/utils/formatters';
import LaudosService from '@/services/LaudosService';
import TipoLaudo from '@/constants/TipoLaudo';
import StatusCar from '@/constants/StatusCar';
import BaseButton from '@/components/vegaComponents/BaseButton.vue';

export default {
    name: 'SelecionarCar',
    components: {
        BaseButton
    },
    props: {
        tipoLaudo: {
            type: Number,
            required: true
        },
        ano: {
            type: Number,
            default: null
        },
        produtorBiomassa: {
            type: Object,
            default: null
        },
        pessoas: {
            type: Array,
            default: () => []
        }
    },
    emits: ['cancelar-modal', 'getLaudos', 'carJaCadastradosEncontrados'],
    data() {
        return {
            carSelecionado: '',
            carExibicao: null,
            car: {},
            existeCarNaBaseLyra: false,
            informacaoLaudosTipo: [],
            confirmacaoAutomaticaLaudo: false
        };
    },
    computed: {
        isValid() {
            return this.ano && (!this.produtorBiomassa || this.produtorBiomassa.valido);
        }
    },
    watch: {
        carSelecionado(value) {
            const CAR_SEM_FORMATACAO = 41;
            const CAR_COM_FORMATACAO = 43;
            if (!value) return;
            if (
                value.length === CAR_SEM_FORMATACAO ||
                value.length === CAR_COM_FORMATACAO
            ) {
                let mascara = '';
                value = value.replace(/[^\w\s]/gi, '');
                mascara = formatters.formatCar(value);
                this.carSelecionado = mascara;
                this.pesquisaValida = true;
            } else {
                this.pesquisaValida = false;
            }
        }
    },
    mounted() {
        window.addEventListener('keydown', function (event) {
            if (event.keyCode === 13) {
                event.preventDefault();
            }
        });
    },
    created() {
        if (this.$route.query.acao === 'SOLICITAR_LAUDO_RENOVABIO') {
            this.carSelecionado = this.$route.query.car;
            setTimeout(() => {
                this.buscarCar();
            }, 100);
        }
    },
    methods: {
        async buscarCar() {
            if (!this.pesquisaValida) {
                this.$notify.warning(
                    this.$t(
                        'mensagens.diagnosticoSocioambiental.erro.informacaoInvalida'
                    )
                );
                return;
            }
            if (this.carSelecionado === this.car.codigo) {
                return;
            }
            try {
                await UtilsService.getDadosCARSemGeometria(
                    this.carSelecionado
                ).then(({ data }) => {
                    if (data) {
                        this.carExibicao = {
                            areaHa: formatters.formatNumber(data.areaHa, 2),
                            municipioUF: `${data.nomeMunicipio}/${data.uf}`,
                            situacao: StatusCar[data.situacao]
                        };
                        this.car = {
                            codigo: data.codigo,
                            condicao: data.situacao
                        };
                        this.existeCarNaBaseLyra = true;
                    } else {
                        this.existeCarNaBaseLyra = false;
                    }
                });

                await UtilsService.getDadosCAR({
                    codigosCar: this.carSelecionado
                }).then(({ data }) => {
                    this.car = {
                        codigo: data.resultados[0].properties.codigo,
                        condicao: data.resultados[0].properties.situacao
                    };
                    this.existeCarNaBaseLyra = data.resultados.length > 0;
                });
            } catch {
                this.carExibicao = null;
                this.$notify.error({
                    message: this.$t(
                        'mensagens.laudos.erro.ocorreuUmErroAoBuscarCar'
                    )
                });
            }
            if (!this.existeCarNaBaseLyra) {
                this.carExibicao = null;
                this.$notify.warning({
                    message: this.$t(
                        'mensagens.laudos.erro.carNaoEncontradoNaBaseDoLyra'
                    )
                });
            }
            $('#idInputCar').trigger('blur');
        },
        enviarCarSelecionado() {
            if (this.tipoLaudo === TipoLaudo.RENOVABIO) {
                this.verificarCarRenovabio();
            } else {
                this.cadastrarLaudos();
            }
        },
        verificarCarRenovabio() {
            if (this.$route.query.acao === 'SOLICITAR_LAUDO_RENOVABIO') {
                this.confirmacaoAutomaticaLaudo = true;
                setTimeout(() => {
                    this.$router.push({
                        name: 'LaudoRenovabio'
                    });
                }, 100);
            }
            let verificarLaudos = [
                {
                    car: this.car.codigo,
                    ano: this.ano,
                    cpfCnpjProdutorBiomassa:
                        formatters.removerPontuacaoDocumento(
                            this.produtorBiomassa.cpfCnpj
                        ),
                    nomeRazaoSocialProdutorBiomassa:
                        this.produtorBiomassa.nomeRazaoSocial
                }
            ];

            LaudosService.verificarLaudosNovos(
                verificarLaudos,
                TipoLaudo.RENOVABIO
            )
                .then(response => {
                    const dados = response.data;
                    let informacaoLaudos = [
                        {
                            tipoLaudoId: TipoLaudo.RENOVABIO,
                            ano: this.ano,
                            car: {
                                codigo: this.car.codigo
                            },
                            cpfCnpjProdutorBiomassa:
                                formatters.removerPontuacaoDocumento(
                                    this.produtorBiomassa.cpfCnpj
                                ),
                            nomeRazaoSocialProdutorBiomassa:
                                this.produtorBiomassa.nomeRazaoSocial
                        }
                    ];

                    if (dados.quantidadeDuplicados > 0) {
                        this.$emit(
                            'carJaCadastradosEncontrados',
                            dados.quantidadeDuplicados,
                            informacaoLaudos,
                            dados.cars,
                            this.confirmacaoAutomaticaLaudo
                        );
                        this.cancelarModal();
                    } else {
                        this.cadastrarLaudos(informacaoLaudos);
                    }
                })
                .catch(error => {
                    this.$notify.error({
                        message: error.message
                    });
                });
        },
        cadastrarLaudos(informacaoLaudos = null) {
            if (!informacaoLaudos) {
                informacaoLaudos = [
                    {
                        tipoLaudoId: this.tipoLaudo,
                        car: this.car
                    }
                ];

                if (
                    this.tipoLaudo === TipoLaudo.CONFORMIDADE &&
                    this.pessoas.length > 0
                ) {
                    informacaoLaudos[0].proprietarios = this.pessoas;
                }
            }

            LaudosService.cadastrarLaudos({ informacaoLaudos })
                .then(() => {
                    this.$notify.success({
                        message: this.$t(
                            'mensagens.laudos.solicitacaoRealizadaComSucesso'
                        )
                    });
                    this.$emit('getLaudos');
                    this.cancelarModal();
                })
                .catch(error => {
                    this.$notify.error({
                        message: error.message
                    });
                });
        },
        cancelarModal() {
            this.$emit('cancelar-modal');
        }
    }
};
</script>

<style lang="scss" scoped>
#selecionar-car {
    .conteudo {
        min-height: auto;
        max-height: 50vh;
        overflow-y: auto;
        color: #00413c;
        margin: 1.5rem 0;
        display: flex;
        flex-wrap: wrap;
        overflow: auto;
        width: 100%;
    }
    .botao {
        margin-top: 10px;
        text-align: right;
        display: flex;
        justify-content: right;

        .cancel-button {
            border: 1px solid #00413c !important;
            color: #00413c !important;
            font-size: 14px;
            height: 2.5rem;
            width: auto;
        }

        .confirm-button {
            width: 10rem;
            height: 2.5rem;
            width: auto;
            font-size: 14px;
        }
    }

    .custom-divider {
        margin-bottom: 10px;
        margin-top: 0px;
    }
}
</style>
